var $59b4d10cc7527295$exports = {};
$59b4d10cc7527295$exports = {
    "info": `Informaci\xf3n`,
    "negative": `Error`,
    "notice": `Advertencia`,
    "positive": `\xc9xito`
};


export {$59b4d10cc7527295$exports as default};
//# sourceMappingURL=es-ES.mjs.map
